import axios from 'axios';
import { ConsultaDetalheTurmaProps, Service } from './consulta-detalhe-turma.types';

export const consultaDetalheTurmaService: Service<ConsultaDetalheTurmaProps> = async ({
  idTurma,
  token,
  urlBase,
  matricula,
}) => {
  const authorization = `Bearer ${token}`;

  const path = `${urlBase}/turmas/${idTurma}/detalhes`;

  const { data } = await axios.get(path, { headers: { authorization }, params: { matricula } });

  return data;
};
